import PropertyTitle from './PropertyTitle';

export default PropertyTitle;
